/**
 * Returns the gauge select options "solid" products
 */
export const getGaugeSelectOptions = (): string[] => {
  let arrayHilos = [
    "0,13",
    "0,18",
    "0,15",
    "0,20",
    "0,25",
    "0,30",
    "0,35",
    "0,40",
    "0,45",
    "0,50",
    "0,55",
    "0,60",
    "0,65",
    "0,70",
    "0,75",
    "0,80",
    "0,85",
    "0,90",
    "0,95",
    "1,00",
    "1,00 mediana",
    "1,10",
    "1,20",
    "1,20 mediana",
    "1,30",
    "1,40",
    "1,50",
    "1,60",
    "1,70",
    "1,80",
    "1,80 mediana",
    "1,90",
    "2,00",
    "2,10",
    "2,20",
    "2,30",
    "2,40",
    "2,50",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
  ];
  /*let index = 20;
  while (index <= 250) {
    arrayHilos.push(formatNumberWithCommas(index));
    // push also "mediana" modifier on 1 and 1,20
    if (index === 100 || index === 120) {
      arrayHilos.push(`${formatNumberWithCommas(index)} mediana`);
    }
    index += 10;
  }
  */ return arrayHilos.map((h) => String(h));
};

const formatNumberWithCommas = (n: number): string =>
  n > 99 ? String((n / 100).toFixed(2)).replace(".", ",") : "0," + n;

/**
 * returns the label for the gauge select option formating numbers
 * below 100 as 0,gauge
 * @param gauge
 * @returns
 */
export const getGaugeSelectOptionLabel = (gauge: string): string => {
  return gauge.replace(/\d+/g, (repValue) =>
    formatNumberWithCommas(Number(repValue))
  );
};
